<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark>
      {{ $t('globalOrganizationsPage.pageTitle') }}
    </v-toolbar>

    <!--    <v-sheet color="grey lighten-3"-->
<!--             class="px-4 pt-4 pb-3"-->
<!--             tile>-->
<!--      <h3 class="transition-swing font-weight-medium">Фильтрация</h3>-->
<!--      <div class="px-4">-->
<!--        <v-row>-->
<!--          <v-col cols="12" sm="6" md="3" lg="3" class="">-->
<!--            <v-autocomplete v-model="filters.unit"-->
<!--                            :items="units"-->
<!--                            label="Филиал"-->
<!--                            item-text="name"-->
<!--                            item-value="id"-->
<!--                            :clearable="true"-->
<!--                            @change="load"-->
<!--            />-->
<!--          </v-col>-->
<!--          <v-col cols="12" sm="6" md="3" lg="3" class="">-->
<!--            <v-text-field-->
<!--                label="ИНН"-->
<!--                v-model="filters.inn"-->
<!--                :clearable="true"-->
<!--                @change="load"-->
<!--            />-->
<!--          </v-col>-->
<!--          <v-spacer/>-->
<!--        </v-row>-->
<!--      </div>-->
<!--    </v-sheet>-->


<v-data-table
        :items="organizations"
        :server-items-length="total"
        :headers="headers"
        style="margin-top: 20px;"
        hide-default-footer
    >
      <template v-slot:item.createdOn="{item}">
        {{ item.createdOn.format('DD.MM.YYYY HH:mm:ss') }}
      </template>

      <template v-slot:item.contractDateFrom="{item}">
        <template v-if="item.contractDateFrom">
          {{ item.contractDateFrom.format('DD.MM.YYYY') }}
        </template>
        <template v-else>
          <v-icon>mdi-calendar-remove</v-icon>
        </template>
      </template>

      <template v-slot:item.contractDateTo="{item}">
        <template v-if="item.contractDateTo">
          {{ item.contractDateTo.format('DD.MM.YYYY') }}
        </template>
        <template v-else>
          <v-icon>mdi-calendar-remove</v-icon>
        </template>
      </template>

      <template v-slot:item.isActive="{item}">
        <v-icon v-if="item.isActive">mdi-check-outline</v-icon>
        <v-icon v-else>mdi-lock-alert</v-icon>
      </template>

      <template v-slot:item.actions="{item}">
        <div class="d-flex justify-end">
          <v-btn icon small :to="{name: 'admin-globalusers', query: {inn: item.inn}}" :title="$t('globalOrganizationsPage.tooltips.users')">
            <v-icon>mdi-account-group</v-icon>
          </v-btn>
          <v-btn icon small :to="{name: 'admin-globalunits', query: {inn: item.inn}}" :title="$t('globalOrganizationsPage.tooltips.departments')">
            <v-icon>mdi-office-building</v-icon>
          </v-btn>
        </div>
      </template>

    </v-data-table>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import _ from 'underscore'
import Mappers from '@/mappers'
import GlobalOrganizationService from "@/services/global.organization.service";
import GlobalUnitService from "@/services/global.unit.service";

export default {
  name: "GlobalOrganizationsPage",
  data() {
    return {
      organizations: [],
      units: [],
      total: 0,
      filters: {
        inn: null,
        unit: null,
        start: null,
        end: null
      },

      currentItem: null,
    }
  },
  computed: {
    headers: function () {
      const headers = []

      headers.push({
        text: this.$t('tableHeaders3.number'),
        align: 'center',
        sortable: false,
        value: 'displayNumber'
      })

      headers.push({
        text: this.$t('tableHeaders3.name'),
        align: 'left',
        sortable: false,
        value: 'name'
      })

      headers.push({
        text: this.$t('tableHeaders3.tin'),
        align: 'center',
        sortable: false,
        value: 'inn'
      })

      headers.push({
        text: this.$t('tableHeaders3.address'),
        align: 'left',
        sortable: false,
        value: 'address'
      })

      headers.push({
        text: this.$t('tableHeaders3.registrationDate'),
        align: 'center',
        sortable: false,
        value: 'createdOn'
      })

      headers.push({
        text: this.$t('tableHeaders3.contractNumber'),
        align: 'center',
        sortable: false,
        value: 'contractNumber'
      })

      headers.push({
        text: this.$t('tableHeaders3.contractDateFrom'),
        align: 'center',
        sortable: false,
        value: 'contractDateFrom'
      })

      headers.push({
        text: this.$t('tableHeaders3.contractDateTo'),
        align: 'center',
        sortable: false,
        value: 'contractDateTo'
      })

      headers.push({
        text: this.$t('tableHeaders3.contractSignerBranch'),
        align: 'center',
        sortable: false,
        value: 'contractSignerGlobalUnit'
      })

      headers.push({
        text: this.$t('tableHeaders3.mailsCount'),
        align: 'center',
        sortable: false,
        value: 'mailsCount'
      })

      headers.push({
        text: this.$t('tableHeaders3.status'),
        align: 'center',
        sortable: false,
        value: 'isActive'
      })


      headers.push({
        text: '',
        align: 'center',
        sortable: false,
        value: 'actions'
      })

      return headers
    }
  },
  methods: {
    load() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      GlobalOrganizationService.getOrganizations({unitId: this.filters.unit, inn: this.filters.inn})
          .then(response => {
            let displayNumber = 0
            this.organizations = _.map(response.data, o => {
              let org = Mappers.mapGlobalOrganization(o?.Organization)
              org.mailsCount = o?.CreatedMailsCount + " | " + o?.SentMailsCount
              org.displayNumber = ++displayNumber

              return org
            })
            this.total = this.organizations.length
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadUnits() {
      this.$store.dispatch(LAYOUT_LOADING_START)

      return GlobalUnitService.getUserUnits({inn: this.$store.getters.inn})
          .then(response => {
            let displayNumber = 0
            this.units = _.map(response.data, u => {
              let unit = Mappers.mapGlobalUnit(u)
              unit.displayNumber = ++displayNumber

              return unit
            })
            this.total = this.units.length
            if (this.units.length) {
              if (this.$store.getters.appLogin.unit && this.$store.getters.appLogin.unit.isHead) {
                this.filters.unit = this.$store.getters.appLogin.unit.id;
              } else {
                if (this.$store.getters.appLogin.globalunit) {
                  this.filters.unit = this.$store.getters.appLogin.globalunit.id;
                } else {
                  this.filters.unit = null; // or some other default value
                }
              }
            }
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('globalOrganizationsPage.pageTitle'))

    this.loadUnits()
        .then(() => {
          this.load()
        })
  }
}
</script>

<style scoped>

</style>